/**
 * 批量铺货平台配置文件
 * 用于定义不同平台的组件、API和配置信息
 */

// 平台批量铺货配置
export const PLATFORM_BATCH_CONFIG = {
  // 抖音平台配置
  fxg: {
    key: 'fxg',
    name: '抖音',
    icon: 'doudian_new.png',
    stepOneComponent: () => import('../platforms/fxg/stepOne.vue'),
    stepTwoComponent: () => import('../platforms/fxg/stepTwo.vue'),
    api: {
      saveBatchTempConf: '/fxg/saveBatchTempConf',
      queryBatchDetail: '/fxg/queryBatchDetail', 
      batchPublishItem: '/fxg/batchPublishItem'
    },
    // 平台特定配置
    config: {
      supportReduceType: true,        // 支持减库存类型
      supportPresellType: true,       // 支持预售模式
      supportSizeTemplate: true,      // 支持尺码模板
      supportShelfType: true,         // 支持上架设置
      maxPresellDays: 30,            // 最大预售天数
      deliveryDelayOptions: [24, 48, 72, 120, 168] // 发货时效选项(小时)
    }
  },
  
  // 拼多多平台配置
  pdd: {
    key: 'pdd',
    name: '拼多多',
    icon: 'icon_pdd_new.png',
    stepOneComponent: () => import('../platforms/pdd/stepOne.vue'),
    stepTwoComponent: () => import('../platforms/pdd/stepTwo.vue'),
    api: {
      saveBatchTempConf: '/pdd/saveBatchTempConf',
      queryBatchDetail: '/pdd/queryBatchDetail',
      batchPublishItem: '/pdd/batchPublishItem'
    },
    // 拼多多特定配置
    config: {
      supportReduceType: false,       // 不支持减库存类型选择
      supportPresellType: false,      // 不支持预售模式
      supportSizeTemplate: false,     // 不支持尺码模板
      supportShelfType: true,         // 支持上架设置
      supportGroupBuy: true,          // 支持团购设置
      supportCoupon: true,            // 支持优惠券设置
      deliveryDelayOptions: [24, 48, 72] // 发货时效选项(小时)
    }
  },
  kuaishou: {
    key: 'kuaishou',
    name: '快手',
    // icon: 'doudian_new.png',
    stepOneComponent: () => import('../platforms/kuaishou/stepOne.vue'),
    stepTwoComponent: () => import('../platforms/kuaishou/stepTwo.vue'),
    api: {
      saveBatchTempConf:'/kuaishou/batchPublish/saveBatchTempConf',
      queryBatchDetail: '/kuaishou/batchPublish/confirmPriceStock', 
      batchPublishItem: '/kuaishou/batchPublish/batchPublishItem'
    },
    // 平台特定配置
    config: {}
  },
  // 淘宝平台配置
  tb:{
    key: 'tb',
    name: '淘宝',
    // icon: 'icon_pdd_new.png',
    stepOneComponent: () => import('../platforms/tb/stepOne.vue'),
    stepTwoComponent: () => import('../platforms/tb/stepTwo.vue'),
    api: {
      queryBatchDetail: '/tb/batchPublish/confirmPriceStock',
      // saveBatchTempConf: '/tb/batchPublish/confirmPriceStock',
      // queryBatchDetail: '/tb/queryBatchDetail',
      // batchPublishItem: '/tb/batchPublishItem'
    },
  },
  // 微信视频号
  wxsph: {
    key: 'wxsph',
    name: '微信小店(视频号)',
    // icon: 'doudian_new.png',
    stepOneComponent: () => import('../platforms/wxsph/stepOne.vue'),
    stepTwoComponent: () => import('../platforms/wxsph/stepTwo.vue'),
    api: {
      saveBatchTempConf: '/wxsph/saveBatchTempConf',
      // queryBatchDetail: '/wxsph/queryBatchDetail', 
      batchPublishItem: '/wxsph/batchPublishItem'
    },
    // 平台特定配置
    config: {
    }
  },
  // 小红书平台配置
  xhs: {
    key: 'xhs',
    name: '小红书',
    // icon: 'icon_pdd_new.png',
    stepOneComponent: () => import('../platforms/xhs/stepOne.vue'),
    stepTwoComponent: () => import('../platforms/xhs/stepTwo.vue'),
    api: {
      saveBatchTempConf: '/xhs/saveBatchTempConf',
      queryBatchDetail: '/xhs/queryBatchDetail',
      batchPublishItem: '/xhs/batchPublishItem'
    },
  },
  // 京东平台配置
  jd: {
    key: 'jd',
    name: '京东',
    // icon: 'doudian_new.png',
    stepOneComponent: () => import('../platforms/jd/stepOne.vue'),
    stepTwoComponent: () => import('../platforms/jd/stepTwo.vue'),
    api: {
      saveBatchTempConf: '/jd/saveBatchTempConf',
      queryBatchDetail: '/jd/queryBatchDetail', 
      batchPublishItem: '/jd/batchPublishItem'
    },
    // 平台特定配置
    config: {}
  },
}

// 获取平台配置
export function getPlatformConfig(platform) {
  return PLATFORM_BATCH_CONFIG[platform] || null
}

// 获取平台API配置
export function getPlatformApi(platform) {
  const config = getPlatformConfig(platform)
  return config ? config.api : null
}

// 获取平台特定配置
export function getPlatformSpecificConfig(platform) {
  const config = getPlatformConfig(platform)
  return config ? config.config : {}
}

// 获取支持的平台列表
export function getSupportedPlatforms() {
  return Object.keys(PLATFORM_BATCH_CONFIG)
}

// 检查平台是否支持某个功能
export function isPlatformFeatureSupported(platform, feature) {
  const config = getPlatformSpecificConfig(platform)
  return config[feature] || false
}